import tree from "../../../components/tree.vue"
import iColumn from "../../../components/Column.vue";
import iTable from "../../../components/Table.vue";
import IPagination from "../../../components/pagination.vue";
import { emailRule } from '@/utility/index.js'

export default {
  name: "DictionaryManaged",
  components: { tree, iColumn, iTable, IPagination },
  data() {
    return {
      formInline: {
        dictName: '',
        dictType: ''
      },
      dialogVisible: false,
      height: '550',
      list: [],
      option: {
        stripe: true,
        border: true,
        loading: false,
        highlightCurrentRow: false,
        mutiSelect: true,
        serialNumber: true,
      },
      columns: [
        {
          prop: "id",
          label: this.$t('DictionaryManaged.id'),
          align: "center",
        },
        {
          prop: "dictName",
          label: this.$t('DictionaryManaged.dictName'),
          align: "center",
        },
        {
          prop: "dictType",
          label: this.$t('DictionaryManaged.dictType'),
          align: "center",
        },
        {
          prop: "remarks",
          label: this.$t('common.remark'),
          align: "center",
        },
        {
          prop: "createTime",
          label: this.$t('common.setUpTime'),
          align: "center",
          width: "300",
          // render: (h, params) => {
          //   return h('span', this.$formatTime(params.row.createTime))
          // }
        }
      ],
      operates: {
        width: 60,
        fixed: "right",
        list: [
          {
            id: '1',
            show: true,
            icon: 'iconfont iconicon-chakanxq',
            plain: true,
            disabled: false,
            dialogFormVisible: false,
            method: (index, row) => {
              this.$router.push({
                path: '/BackgroundSettings/DictionaryManaged/DictionaryItem',
                query: { dictId: row.id }
              })
            }
          }
        ],
      },
      currentPage: 1,
      pageSize: 10,
      total: 1,
      dialogFormVisible: false,
      formLabelWidth: '100px',
      diaTitle: '',
      btnType: '',
      rules: {
        dictName: [
          { required: true, message: this.$t('DictionaryManaged.form.dictName'), trigger: 'blur' },
        ],
        dictType: [
          { required: true, message: this.$t('DictionaryManaged.form.dictType'), trigger: 'blur' }
        ],
      },
      form: {
        dictName: '',
        dictType: '',
        remarks: '',
      },
      selected: [],
    };
  },

  created() {

  },
  mounted() {
    this.getDictionaryList()
  },
  methods: {
    getDictionaryList() {
      let param = {
        dictName: this.formInline.dictName,
        dictType: this.formInline.dictType,
        pageNum: this.currentPage,
        pageSize: this.pageSize
      }
      this.$store.dispatch('DictionaryManaged/GET_GETDICTTYPE', param).then(res => {
        if (res) {
          if (res.data.code == 200) {
            this.list = res.data.data.list
            this.$refs.page.CommandTotal = res.data.data.total
          }
        }
      })
    },
    onSearch() {
      this.currentPage = 1
      this.getDictionaryList()
    },
    onClear() {
      this.formInline = {
        dictName: '',
        dictType: '',
      }
      this.getDictionaryList()
    },
    handleSelectionChange(val) {
      this.selected = val
    },
    changeSize(item) {
      this.pageSize = item.pageSize
      this.currentPage = item.pageNum
      this.getDictionaryList();
    },
    refreshBtn() {
      this.$store.dispatch('DictionaryManaged/GET_REFRESHDATA', {}).then(res => {
        if (res.data.code == 200) {
          this.$message.success(this.$t('common.btn.refreshSuccess'))
          this.getDictionaryList();
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    addUser() {
      this.dialogFormVisible = true;
      this.diaTitle = this.$t('common.btn.add')
      this.btnType = 'add'
      this.$nextTick(() => {
        this.$refs.form.resetFields()
      })

    },
    editUser() {
      this.dialogFormVisible = true;
      this.diaTitle = this.$t('common.btn.edit')
      this.btnType = 'edit'
      this.$nextTick(() => {
        this.$refs.form.clearValidate()
        this.form.dictName = this.selected[0].dictName
        this.form.dictType = this.selected[0].dictType
        this.form.remarks = this.selected[0].remarks
      })


    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let param = {
            dictName: this.form.dictName,
            dictType: this.form.dictType,
            remarks: this.form.remarks,
          }
          if (this.btnType == 'add') {
            this.$store.dispatch('DictionaryManaged/GET_ADDDICTTYPE', param).then(res => {
              if (res.data.code == 200) {
                this.$message.success(this.$t('common.btn.addSuccess'))
                this.dialogFormVisible = false;
                this.getDictionaryList();
                this.closeDia();
              } else {
                this.$message.error(res.data.msg)
              }

            }).catch(err => { })
          } else {
            param.id = this.selected[0].id
            this.$store.dispatch('DictionaryManaged/GET_UPDATEDICTTYPE', param).then(res => {
              if (res.data.code == 200) {
                this.$message.success(this.$t('common.btn.editSuccess'))
                this.dialogFormVisible = false;
                this.getDictionaryList();
                this.closeDia();
              } else {
                this.$message.error(res.data.msg)
              }

            }).catch(err => { })
          }
        } else {
          return false;
        }
      });
    },
    cancle(formName) {
      this.dialogFormVisible = false;
      this.form = {
        dictName: '',
        dictType: '',
        remarks: '',
      }
    },
    closeDia() {
      this.form = {
        dictName: '',
        dictType: '',
        remarks: '',
      }
      this.dialogFormVisible = false;
    },

    deleteUser() {
      this.$confirm(this.$t('common.btn.confirmDelete'), this.$t('common.btn.hint'),
        {
          cancelButtonText: this.$t('common.btn.cancel'),
          confirmButtonText: this.$t('common.btn.confirm'),
          type: 'warning'
        }).then(res => {
          let param = { id: this.selected[0].id }
          this.$store.dispatch('DictionaryManaged/GET_DELETEDICTTYPE', param).then(response => {
            if (response.data.code == 200) {
              this.getDictionaryList()
              this.$message.success(this.$t('common.btn.deleteSuccess'))
            } else {
              this.$message.error(response.data.msg)
            }
          }).catch(error => { })
        }).catch(err => {

        })
    },

    changeSort(item) {
      this.columns = [];
      this.$nextTick(function () {
        this.columns = item;
      });
    },

    ListSetting() {
      this.$refs.listSet.dialogVisible = true;
    },
  },
};
